module.exports = __webpack_public_path__ + "media/images/icons/sliders-6c16a5e03c03620d59cc6e306a7eec5b.svg";